<!--
/*
 * @Description: 第一手机登录 设置密码
 * @Author: Guojun
 * @Date: 2020-05-19 14:43:48
 * @LastEditTime: 2020-5-20 09:02:47
 */
  -->
<template>
  <div class="setphoneLogin">
    <p class="phoneHint">设置登录密码</p>
    <p class="phoneHint" style="margin-top:10px;">我们已为您创建新的平台账号，登录后可修改一次，这是您的第一次登录，请完善登录密码</p>
    <el-form ref="setPassword" :model="setPassword" :rules="rules">
      <el-form-item prop="newPassword1" class="phoneCode-item">
        <el-input
          placeholder="设置登录密码 （数字+字母，6-16位）"
          v-model="setPassword.newPassword1"
          class="input-with-select"
          maxlength="16"
          show-password
          @keyup.enter.native="loginBtn()"
        ></el-input>
      </el-form-item>
      <el-form-item prop="newPassword2">
        <el-input
          placeholder="再次设置登录密码"
          v-model="setPassword.newPassword2"
          maxlength="16"
          show-password
          class="phoneCode"
          @keyup.enter.native="loginBtn()"
        ></el-input>
      </el-form-item>
      <el-form-item class="btn">
        <el-button @click.prevent="setPasswords()" class="loginBtn">立即设置登录密码</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Vue from "vue";
import user from "../apis/user_apis";
import utils from "../utils/utils";
import { setPswdRules } from "../validate/rules";
export default {
  data() {
    return {
      show: false,
      setPassword: {
        newPassword1: "",
        newPassword2: "",
      },
      rules: setPswdRules,
    };
  },
  created() {},
  mounted() {},
  methods: {
    setPasswords() {
      let that = this;
      this.$refs.setPassword.validate((valid) => {
        if (valid) {
          user.firstSetPwd(that).then((res) => {
            if (res.success) {
              this.$router.push({
                path: "/index",
              });
              window.location.reload();
            } else {
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
 
<style lang="less" scoped>
.setphoneLogin {
  .phoneHint {
    position: relative;
    top: -30px;
    font-size: 14px;
  }
  .el-form-item {
    height: 60px;
    margin-bottom: 0px !important;
    position: relative;
    /deep/ .el-select {
      width: 100px;
      // margin-right:30px;
    }
    .btn {
      margin-top: 20px;
      height: auto;

      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    /deep/ .el-button + .el-button {
      margin-left: 30px !important;
    }
    /deep/ .el-button {
      padding: 0;
      width: 300px;
      height: 41px;
      font-size: 14px;
      border: 1px solid rgba(250, 217, 0, 1);
      color: #fff;
      font-weight: normal;
      border-radius: 2px;
      background: linear-gradient(
        90deg,
        rgba(250, 217, 0, 1) 0%,
        rgba(250, 190, 0, 1) 100%
      );
      box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
    }
    /deep/ .el-button:hover {
      color: #fff;
      background: rgba(252, 111, 25, 1);
      box-shadow: 0px 3px 12px rgba(250, 108, 0, 0.3);
    }
    /deep/ .el-checkbox__inner {
      border: 1px solid #808495;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      border: 1px solid #dcdfe6;
    }
    /deep/ .el-input__inner:focus {
      // caret-color: #fabe00;
      border-color: #333;
    }
  }
}
</style>